<template>
  <div class="fixed z-20 left-0 top-0 inset-0 flex h-screen w-full">
    <div v-if="popupArticle" class="my-auto mx-auto w-full">
      <UiContentwrapper>
        <UiNarrowcolumn class="relative">
        <button class=" rotate-45 absolute right-8 top-8" @click="closePopup">
            <UiClose :expandStyle="true" />
        </button>
        <div ref="innerpopupRef" class="md:flex md:flex-row gap-16 bg-white shadow-lg p-16">
          
          <div class="w-full" v-html="popupArticle.contenthtml"/>
        </div>
      </UiNarrowcolumn>
      </UiContentwrapper>
    </div>
  </div>
</template>

<script setup>
import { useBlogStore } from '@/stores/blogStore';
import { onClickOutside, useEventListener } from '@vueuse/core';

const UiClose = defineAsyncComponent(() => import('@/components/ui/close.vue'));
// Get the blog store
const blogStore = useBlogStore();

const innerpopupRef = ref(null);

const emit = defineEmits(['close']);

onClickOutside(innerpopupRef, closePopup);

function closePopup() {    
    emit('close');
}

onMounted(() => {
    useEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closePopup();
        }
    })
   })


const { data: optionsBlog, error } = await useAsyncData('optionsBlog', async () => {  
  return await blogStore.fetchBlogByHandle('product-options');
});

const popupArticle = computed(() => {
  try{
    const article = optionsBlog.value.articles.find(article => article.handle === 'rotor-pop-up');
    return article;
  } catch (error) {
    console.error('Error fetching article:', error);
    return null;
  }
});


onMounted(async () => {

  

});
</script>

<style scoped>
/* Add your styles here */
</style>